import { SparklesIcon } from "lucide-react";
import { Focusable } from "react-aria";

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip";

type InsightsSummarizeThemesButtonProps = {
  label: string;
  isPending?: boolean;
  isDisabled?: boolean;
  disabledReason?: string | null;
  onPress: () => void;
};

export function InsightsSummarizeThemesButton({
  label,
  isPending = false,
  isDisabled = false,
  disabledReason,
  onPress,
}: InsightsSummarizeThemesButtonProps) {
  const sharedProps = {
    variant: "outline" as const,
    size: "sm" as const,
    className: "h-7 gap-1 px-2 text-xs",
    children: (
      <>
        <SparklesIcon className="size-3.5" />
        {label}
      </>
    ),
  };

  if (isDisabled && disabledReason) {
    return (
      <TooltipTrigger isDisabled={isPending}>
        <Focusable>
          <Button {...sharedProps} isDisabled />
        </Focusable>
        <Tooltip className="max-w-xs">{disabledReason}</Tooltip>
      </TooltipTrigger>
    );
  }

  return (
    <Button
      {...sharedProps}
      onPress={onPress}
      isPending={isPending}
      isDisabled={isDisabled || isPending}
    />
  );
}
